import Component from './Component';
import axios from 'axios';
import { togglePreloader } from './../services/ScrollResizeHandler';
import { renderNewsTemp } from './../services/Templates';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 let newPromise;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */






/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class ArticleList extends Component {

    decorator () {
        return {
            selector : '.js-article-list',
            name : 'ArticleList',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        this.bindEvents();
    }


    cacheElements () {
        this.button = this.element.querySelector('.js-button');
        this.container = this.element.querySelector('.js-article-list-container');
    }


    bindEvents () {
        // start on 2nd page
        let num = 2;
        this.button.addEventListener('click', e => {
            e.preventDefault();

            togglePreloader();

            setTimeout(() => {
                this.initPromise(num);
                num++
            }, 350);
        });
    }


    initPromise (num = 2) {
        newPromise = axios.get(`/api/article-list/news-and-events?page=${num}`)
            .then(response => {
                return response.data;
            })
            .then(data => {
                const newData = data.data;
                let appendMarkUp;

                for (let i = 0; i < newData.length; i++) {

                    appendMarkUp = renderNewsTemp(newData[i]);

                    this.container.insertAdjacentHTML('beforeend', appendMarkUp);
                }

                return data;
            })
            .then(data => {

                togglePreloader();

                if (data.next_page_url == null) {
                    this.button.parentElement.classList.add('is-hidden');
                }
            })
            .catch(error => {
                console.error(error);
            })
    }

}
